import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../App.css';

const RawMaterialRequests = () => {
    const [requests, setRequests] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [actionLoading, setActionLoading] = useState(null);

    const API_BASE_URL = 'https://rotica.in';

    useEffect(() => {
        fetchRequests();
    }, []);

    const fetchRequests = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`${API_BASE_URL}/get_fofo_requirements.php`, {
                params: { role: 'owner' }
            });
            if (response.data.success) {
                setRequests(response.data.requirements);
            } else {
                setError(response.data.message);
            }
        } catch (err) {
            setError("Failed to fetch requests");
        } finally {
            setLoading(false);
        }
    };

    const handleStatusUpdate = async (id, newStatus) => {
        setActionLoading(id);
        try {
            const formData = new FormData();
            formData.append('id', id);
            formData.append('status', newStatus);
            formData.append('role', 'owner');
            const response = await axios.post(`${API_BASE_URL}/update_fofo_status.php`, formData);
            if (response.data.success) {
                // Optimistic update or refetch
                fetchRequests();
            } else {
                alert(response.data.message);
            }
        } catch (err) {
            alert("Update failed");
        } finally {
            setActionLoading(null);
        }
    };

    return (
        <div className="dashboard-container">
            <div className="dashboard-header">
                <h2>Raw Material Requests</h2>
                <p>Manage and track raw material requirements from manufacturers</p>
            </div>

            {loading ? (
                <div className="loading-state">Loading requests...</div>
            ) : error ? (
                <div className="error-state">{error}</div>
            ) : (
                <div className="table-container">
                    <table className="orders-table">
                        <thead>
                            <tr>
                                <th>Requested By</th>
                                <th>Raw Material</th>
                                <th>Quantity</th>
                                <th>Date Requested</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {requests.length === 0 ? (
                                <tr>
                                    <td colSpan="6" style={{ textAlign: 'center', padding: '20px' }}>No active requests</td>
                                </tr>
                            ) : (
                                requests.map((req) => (
                                    <tr key={req.id} style={req.status === 'closed' ? { opacity: 0.5, background: '#f9f9f9', pointerEvents: 'none' } : {}}>
                                        <td><strong>{req.entity_name}</strong></td>
                                        <td>
                                            {req.product_name}
                                            <div style={{ fontSize: '12px', color: '#666' }}>
                                                {req.weight_spec} | {req.size_spec}
                                            </div>
                                        </td>
                                        <td>{req.required_qty || 0}</td>
                                        <td>{new Date(req.created_at).toLocaleString()}</td>
                                        <td>
                                            <span className={`status-badge ${req.status}`}>
                                                {req.status ? req.status.replace(/_/g, ' ') : ''}
                                            </span>
                                        </td>
                                        <td>
                                            <select
                                                className="status-dropdown"
                                                value={req.status}
                                                disabled={actionLoading === req.id || req.status === 'processed' || req.status === 'closed'}
                                                onChange={(e) => handleStatusUpdate(req.id, e.target.value)}
                                                style={{
                                                    padding: '6px 12px',
                                                    borderRadius: '6px',
                                                    border: '1px solid #ddd',
                                                    backgroundColor: (req.status === 'processed' || req.status === 'closed') ? '#f5f5f5' : 'white',
                                                    cursor: (req.status === 'processed' || req.status === 'closed') ? 'not-allowed' : 'pointer'
                                                }}
                                            >
                                                <option value="generated">Generated</option>
                                                <option value="processing">Processing</option>
                                                <option value="out for delivery">Out for Delivery</option>
                                                <option value="processed" disabled>Processed</option>
                                            </select>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default RawMaterialRequests;
